export const SYSTEM_LANGUAGE_ACTIONS = {
    LIST: 'system_language_list'
}